<template>
 <div>
    <b-field>
      <template v-if="label" slot="label">
        <qd-label :label="label" />
      </template>
      <b-taginput
        v-model="itemsSelected"
        :data="filteredItems"
        :loading="isFetching"
        :confirm-keys="['Tab', 'Enter']"
        :before-adding="beforeAdding"
        :open-on-focus="true"
        field="libelle"
        type="is-primary"
        ref="tag"
        autocomplete>
        <template #selected="{ tags }">
          <b-tag
            v-for="(tag, index) in tags" :key="index"
            @close="$refs.tag.removeTag(index, $event)"
            :type="chooseTagType(tag)"
            closable>
            {{tag ? tag.libelle : ''}}
          </b-tag>
        </template>
        <template slot="empty">
          {{ !isFetching ? $t('general.autocomplete.noRslt') : $t('general.autocomplete.search')}}
        </template>
      </b-taginput>
    </b-field>
 </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import QdLabel from '@/components/general/qdLabel.vue';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

const Parametres = createNamespacedHelpers('parametrage');

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  components: {
    QdLabel,
  },
  data() {
    return {
      isFetching: false,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    itemsSelected: {
      get() {
        return this.parametre(PARAMETRES_KEYS.marque).filter((item) => {
          return this.value.map(i => i.marqueId).includes(item.id);
        });
      },
      set(list) {
        this.$emit('input', list.map(el => ({ marqueId: el.id })));
      },
    },
    filteredItems() {
      return this.parametre(PARAMETRES_KEYS.marque).filter((item) => {
        return !this.value.map(i => i.marqueId).includes(item.id);
      });
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    chooseTagType(tag) {
      if (!!tag && !tag.actif) return 'striped-background has-text-weight-bold mgr-2';
      if (!!tag && !tag.couleur) return 'is-primary has-text-white mgr-2';
      return 'has-text-white mgr-2';
    },
    beforeAdding(value) {
      return !this.itemsSelected.some((item) => {
        if (typeof value === 'object') return item.id === value.id;
        return item.libelle.toLowerCase() === value.toLowerCase();
      });
    },
    async loadMarques() {
      this.isFetching = true;
      try {
        await this.loadParametres([PARAMETRES_KEYS.marque]);
      } catch (error) {
        gestionErreur(this.$i18n.t('general.validation.error'), error);
        throw error;
      } finally {
        this.isFetching = false;
      }
    },
  },
  async mounted() {
    await this.loadMarques();
  },
};
</script>
